import React from 'react';

const DateComponent = ({ date }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${day} / ${month} / ${year}`;
  };

  return <span className="">{formatDate(date)}</span>;
};

export default DateComponent;
